export interface ViewToggleButton {
  selected: boolean;
}

export enum ViewType {
  INSIGHTS = 'insights',
  PRICING = 'pricing',
}

export interface ViewToggleButtons {
  [ViewType.INSIGHTS]: ViewToggleButton;
  [ViewType.PRICING]: ViewToggleButton;
}
